


// import React, { useState, useCallback, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   Typography,
//   Paper,
//   Divider,
//   CircularProgress,
//   Alert,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Snackbar,
// } from "@mui/material";
// import RestartAltIcon from "@mui/icons-material/RestartAlt";
// import SendIcon from "@mui/icons-material/Send";
// import SaveIcon from "@mui/icons-material/Save";
// import CloseIcon from "@mui/icons-material/Close";
// import PrintIcon from "@mui/icons-material/Print";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
// import { TextField, Autocomplete } from "@mui/material";

// // ─── Font & API Base ─────────────────────────────────────────────────────────
// import krutiFont from "../assets/fonts/krutidev-010-hindi-font-download.ttf";

// const _style = document.createElement("style");
// _style.innerHTML = `
//   @font-face {
//     font-family: 'KrutiDev010';
//     src: url('${krutiFont}') format('truetype');
//     font-weight: normal;
//     font-style: normal;
//   }
// `;
// document.head.appendChild(_style);

// export const KRUTI_FONT = "'KrutiDev010', 'Kruti Dev 010', 'Mangal', serif";
// export const API_BASE = "https://krutidevbackend.patanjaliyogafoundation.online";

// // ─── Kruti Dev Unicode → ASCII Map ───────────────────────────────────────────
// export const KRUTI_MAP = new Map([
//   ["\u0915\u094D\u0937", "{k"], ["\u091C\u094D\u091E", "K"],
//   ["\u0905", "v"],   ["\u0906", "vk"],  ["\u0907", "b"],   ["\u0908", "bZ"],
//   ["\u0909", "m"],   ["\u090A", "\u00C5"], ["\u090B", "_"],   ["\u090F", ","],
//   ["\u0910", ",s"],  ["\u0913", "vks"], ["\u0914", "vkS"], ["\u0915", "d"],
//   ["\u0916", "[k"],  ["\u0917", "x"],   ["\u0918", "?k"],  ["\u091A", "p"],
//   ["\u091B", "N"],   ["\u091C", "t"],   ["\u091D", ">"],   ["\u091F", "V"],
//   ["\u0920", "B"],   ["\u0921", "M"],   ["\u0922", "<"],   ["\u0923", ".k"],
//   ["\u0924", "r"],   ["\u0925", "Fk"],  ["\u0926", "n"],   ["\u0927", "/k"],
//   ["\u0928", "u"],   ["\u092A", "i"],   ["\u092B", "iQ"],  ["\u092C", "c"],
//   ["\u092D", "Hk"],  ["\u092E", "e"],   ["\u092F", ";"],   ["\u0930", "j"],
//   ["\u0932", "y"],   ["\u0935", "o"],   ["\u0936", "'k"],  ["\u0937", "\"k"],
//   ["\u0938", "l"],   ["\u0939", "g"],   ["\u0933", "G"],   ["\u093E", "k"],
//   ["\u093F", "f"],   ["\u0940", "h"],   ["\u0941", "q"],   ["\u0942", "w"],
//   ["\u0943", "+"],   ["\u0947", "s"],   ["\u0948", "S"],   ["\u094B", "ks"],
//   ["\u094C", "kS"],  ["\u0902", "a"],   ["\u0903", "%"],   ["\u0901", "\u00A1"],
//   ["\u094D", "~"],   ["\u0964", "A"],   ["\u0965", "AA"],
//   ["\u0966", "0"],   ["\u0967", "1"],   ["\u0968", "2"],   ["\u0969", "3"],
//   ["\u096A", "4"],   ["\u096B", "5"],   ["\u096C", "6"],   ["\u096D", "7"],
//   ["\u096E", "8"],   ["\u096F", "9"],   [" ", " "],        ["\n", "\n"],
// ]);

// export function toKruti(text) {
//   if (!text) return "";
//   let result = "";
//   let i = 0;
//   while (i < text.length) {
//     let found = false;
//     for (let len = 3; len >= 1; len--) {
//       const chunk = text.substring(i, i + len);
//       if (KRUTI_MAP.has(chunk)) {
//         result += KRUTI_MAP.get(chunk);
//         i += len;
//         found = true;
//         break;
//       }
//     }
//     if (!found) { result += text[i]; i++; }
//   }
//   return result;
// }

// // ─── Print Engine ────────────────────────────────────────────────────────────
// export function doPrint(name, addr) {
//   const html = `<!DOCTYPE html>
// <html><head><meta charset="UTF-8"/>
// <style>
// @font-face{font-family:'KrutiDev010';src:url('${window.location.origin}${krutiFont}') format('truetype');}
// @page{size:A4;margin:2.5cm;}
// *{box-sizing:border-box;margin:0;padding:0;}
// body{font-family:'KrutiDev010','Mangal',serif;color:#111;background:#fff;}
// .bar{background:#1565C0;height:8px;width:100%;margin-bottom:32px;}
// .hdr{text-align:center;margin-bottom:24px;}
// .hdr h1{font-family:Arial,sans-serif;font-size:22pt;font-weight:700;color:#1565C0;}
// .hdr p{font-family:Arial,sans-serif;font-size:11pt;color:#777;margin-top:4px;text-transform:uppercase;letter-spacing:2px;}
// hr{border:none;border-top:1.5px solid #1565C0;margin:0 0 28px;}
// .row{display:flex;align-items:flex-start;margin-bottom:22px;padding-bottom:22px;border-bottom:.5px solid #e0e0e0;}
// .row:last-of-type{border-bottom:none;}
// .lbl{font-family:Arial,sans-serif;font-size:10pt;font-weight:700;color:#1565C0;width:150px;min-width:150px;text-transform:uppercase;letter-spacing:.5px;}
// .col{font-size:12pt;color:#1565C0;margin:0 12px;}
// .val{font-family:'KrutiDev010','Mangal',serif;font-size:15pt;color:#1a1a2e;flex:1;white-space:pre-wrap;word-break:break-word;border-bottom:1px solid #b0b0b0;padding-bottom:2px;min-height:22px;}
// .bot{background:#1565C0;height:4px;width:100%;margin-top:40px;}
// .ftr{text-align:right;font-family:Arial,sans-serif;font-size:8pt;color:#aaa;margin-top:10px;}
// </style></head><body>
// <div class="bar"></div>
// <div class="hdr"><h1>Student Information</h1><p>Official Record Form</p></div>
// <hr/>
// <div class="row"><div class="lbl">Student Name</div><div class="col">:</div><div class="val">${name||""}</div></div>
// <div class="row"><div class="lbl">Address</div><div class="col">:</div><div class="val">${addr||""}</div></div>
// <div class="bot"></div>
// <div class="ftr">Printed: ${new Date().toLocaleDateString("en-IN")} &nbsp; ${new Date().toLocaleTimeString("en-IN")}</div>
// </body></html>`;
//   const w = window.open("", "_blank");
//   w.document.write(html);
//   w.document.close();
//   w.focus();
//   setTimeout(() => { w.print(); w.close(); }, 800);
// }

// // ─── Sub Components ──────────────────────────────────────────────────────────
// function KrutiField({ value, onChange, multiline, placeholder, disabled }) {
//   const handleChange = useCallback((e) => onChange(toKruti(e.target.value)), [onChange]);
//   const base = {
//     width: "100%", fontFamily: KRUTI_FONT, fontSize: "17px", padding: "12px 16px",
//     border: "1px solid rgba(21, 101, 192, 0.2)", borderRadius: "12px", outline: "none",
//     background: disabled ? "rgba(240, 244, 248, 0.5)" : "rgba(255, 255, 255, 0.7)",
//     color: "#1a1a2e", resize: "none", lineHeight: 1.7, boxSizing: "border-box",
//     transition: "all 0.2s ease", cursor: disabled ? "not-allowed" : "text", opacity: disabled ? 0.7 : 1,
//     boxShadow: "inset 0 2px 4px rgba(0,0,0,0.02)",
//   };
//   const focus = (e) => { if (!disabled) { e.target.style.borderColor = "#1565C0"; e.target.style.boxShadow = "0 0 0 3px rgba(21, 101, 192, 0.15)"; } };
//   const blur  = (e) => { e.target.style.borderColor = "rgba(21, 101, 192, 0.2)"; e.target.style.boxShadow = "inset 0 2px 4px rgba(0,0,0,0.02)"; };

//   return multiline ? (
//     <textarea rows={4} value={value} onChange={handleChange} placeholder={placeholder} style={base} disabled={disabled} onFocus={focus} onBlur={blur} />
//   ) : (
//     <input type="text" value={value} onChange={handleChange} placeholder={placeholder} style={base} disabled={disabled} onFocus={focus} onBlur={blur} />
//   );
// }

// function KrutiAutocomplete({ value, onChange, options, disabled, placeholder }) {
//   const uniqueNames = Array.from(new Set(options.map(s => s.name).filter(Boolean)));
//   const baseStyle = { fontFamily: KRUTI_FONT, fontSize: "17px", color: "#1a1a2e" };

//   return (
//     <Autocomplete
//       freeSolo
//       disabled={disabled}
//       options={uniqueNames}
//       value={value}
//       onChange={(event, newValue) => onChange(newValue || "")}
//       onInputChange={(event, newInputValue) => onChange(toKruti(newInputValue))}
//       renderOption={(props, option) => (
//         <li {...props} style={{ ...baseStyle, padding: "10px 16px" }}>{option}</li>
//       )}
//       renderInput={(params) => (
//         <TextField
//           {...params}
//           placeholder={placeholder}
//           variant="outlined"
//           fullWidth
//           inputProps={{
//             ...params.inputProps,
//             style: { ...baseStyle, padding: "4px 4px" },
//           }}
//           sx={{
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "12px", padding: "6px 12px",
//               background: disabled ? "rgba(240, 244, 248, 0.5)" : "rgba(255, 255, 255, 0.7)",
//               border: "1px solid rgba(21, 101, 192, 0.2)", boxShadow: "inset 0 2px 4px rgba(0,0,0,0.02)",
//               transition: "all 0.2s ease",
//               "& fieldset": { border: "none" },
//               "&.Mui-focused": { border: "1px solid #1565C0", boxShadow: "0 0 0 3px rgba(21, 101, 192, 0.15)" },
//             },
//             "& input": { fontFamily: `${KRUTI_FONT} !important` }
//           }}
//         />
//       )}
//     />
//   );
// }

// // ─── Main Component ───────────────────────────────────────────────────────────
// export default function RegistrationForm() {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [name, setName] = useState("");
//   const [addr, setAddr] = useState("");
//   const [editId, setEditId] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const [students, setStudents] = useState([]);
//   const [snack, setSnack] = useState({ open: false, msg: "", sev: "success" });
//   const [printPrompt, setPrintPrompt] = useState({ open: false, name: "", address: "" });

//   const toast = useCallback((msg, sev = "success") => setSnack({ open: true, msg, sev }), []);
//   const resetForm = () => { setName(""); setAddr(""); setEditId(null); };

//   // लोड करताना एडिट स्टेट मॅनेजमेंट तपासणे (List कडून आलेली डेटा)
//   useEffect(() => {
//     if (location.state?.editStudent) {
//       const s = location.state.editStudent;
//       setName(s.name || "");
//       setAddr(s.address || "");
//       setEditId(s.id);
//     }
//   }, [location.state]);

//   useEffect(() => {
//     fetch(`${API_BASE}/students`)
//       .then(res => res.json())
//       .then(data => setStudents(data || []))
//       .catch(() => {});
//   }, []);

//   const handleSubmit = async () => {
//     if (!name.trim()) { toast("Student name bhara", "error"); return; }
//     setSaving(true);
//     try {
//       if (editId !== null) {
//         await fetch(`${API_BASE}/students/${editId}`, {
//           method: "PATCH",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ name, address: addr }),
//         });
//         toast("Student update jhala!");
//       } else {
//         await fetch(`${API_BASE}/students`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ name, address: addr }),
//         });
//         toast("Student save jhala!");
//       }
//       setPrintPrompt({ open: true, name, address: addr });
//       resetForm();
//     } catch (err) {
//       toast(err.message, "error");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handlePrintChoice = (shouldPrint) => {
//     const tempName = printPrompt.name;
//     const tempAddr = printPrompt.address;
//     setPrintPrompt({ open: false, name: "", address: "" });
//     if (shouldPrint) {
//       doPrint(tempName, tempAddr);
//     }
//     navigate("/member-list"); // यशस्वी रित्या सेव झाल्यानंतर लिस्ट कडे रिडायरेक्ट करा
//   };

//   return (
//     <Box sx={{ maxWidth: 1350, mx: "auto", mt: 5, mb: 5, px: 2 }}>
//       <Paper elevation={0} sx={{ 
//         width: "100%", borderRadius: 4, overflow: "hidden", 
//         background: "rgba(255, 255, 255, 0.45)", backdropFilter: "blur(20px)",
//         border: "1px solid rgba(255, 255, 255, 0.6)", boxShadow: "0 20px 40px rgba(0, 0, 0, 0.06)"
//       }}>
//         <Box sx={{ height: 5, background: "linear-gradient(90deg, #1565C0, #42a5f5, #1565C0)" }} />

//         <Box sx={{ px: 4, pt: 4, pb: 2 }}>
//           <Typography variant="h5" fontWeight={800} sx={{ color: "#0f3460" }}>
//             {editId ? "Edit Student Record" : "Student Registration Form"}
//           </Typography>
//         </Box>
//         <Divider sx={{ borderColor: "rgba(21, 101, 192, 0.12)" }} />

//         <Box sx={{ p: 4, background: "rgba(255,255,255,0.2)" }}>
//           {editId && (
//             <Alert severity="info" sx={{ mb: 3, borderRadius: 3 }}
//               action={<IconButton size="small" onClick={resetForm}><CloseIcon fontSize="small" /></IconButton>}
//             >
//               Student <strong>#{editId}</strong> edit ho rahe aahe — Cancel sathi × daba.
//             </Alert>
//           )}

//           <Box sx={{ background: "rgba(255,255,255,0.6)", p: 3, borderRadius: 3, border: "1px solid rgba(255,255,255,0.5)" }}>
//             <Box sx={{ mb: 3.5 }}>
//               <Typography variant="caption" sx={{ fontWeight: 700, color: "#1565C0", display: "block", mb: 1, textTransform: "uppercase" }}>
//                 Student Name *
//               </Typography>
//               <KrutiAutocomplete value={name} onChange={setName} options={students} disabled={saving} placeholder="" />
//             </Box>

//             <Box sx={{ mb: 1 }}>
//               <Typography variant="caption" sx={{ fontWeight: 700, color: "#1565C0", display: "block", mb: 1, textTransform: "uppercase" }}>
//                 Address Location
//               </Typography>
//               <KrutiField value={addr} onChange={setAddr} multiline={true} disabled={saving} placeholder="" />
//             </Box>
//           </Box>

//           <Divider sx={{ mt: 4, mb: 3, opacity: 0.5 }} />

//           <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
//             <Button variant="outlined" startIcon={<RestartAltIcon />} onClick={resetForm} disabled={saving} sx={{ borderRadius: 2.5, textTransform: "none" }}>
//               Reset
//             </Button>
//             <Button variant="contained" endIcon={saving ? <CircularProgress size={16} color="inherit" /> : editId ? <SaveIcon /> : <SendIcon />} onClick={handleSubmit} disabled={saving}
//               sx={{ borderRadius: 2.5, textTransform: "none", minWidth: 140, background: "linear-gradient(135deg, #1565C0 0%, #1976D2 100%)" }}
//             >
//               {saving ? "Saving..." : editId ? "Update " : "Save"}
//             </Button>
//           </Box>
//         </Box>
//       </Paper>

//       {/* Dynamic Submission Print Prompt Dialog */}
//       <Dialog open={printPrompt.open} onClose={() => handlePrintChoice(false)} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 4, p: 1 } }}>
//         <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5, color: "#1b5e20", fontWeight: 800 }}>
//           <CheckCircleOutlineIcon color="success" sx={{ fontSize: 28 }} />
//           Record Successfully Saved!
//         </DialogTitle>
//         <DialogContent><DialogContentText sx={{ color: "#334155" }}>Do you want print?</DialogContentText></DialogContent>
//         <DialogActions sx={{ px: 3, pb: 3, gap: 1.5 }}>
//           <Button onClick={() => handlePrintChoice(false)} variant="outlined" color="error" fullWidth sx={{ textTransform: "none", borderRadius: 3 }}>No</Button>
//           <Button onClick={() => handlePrintChoice(true)} variant="contained" color="success" fullWidth startIcon={<PrintIcon />} sx={{ textTransform: "none", borderRadius: 3, background: "#2e7d32" }}>Yes</Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar open={snack.open} autoHideDuration={3500} onClose={() => setSnack(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
//         <Alert severity={snack.sev} variant="filled" sx={{ width: "100%", borderRadius: 2.5 }}>{snack.msg}</Alert>
//       </Snackbar>
//     </Box>
//   );
// }

import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  createTheme,
  ThemeProvider,
  CssBaseline,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import BadgeIcon from '@mui/icons-material/Badge';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PersonIcon from '@mui/icons-material/Person';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LanguageIcon from '@mui/icons-material/Language';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import GroupsIcon from '@mui/icons-material/Groups';
import PeopleIcon from '@mui/icons-material/People';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapIcon from '@mui/icons-material/Map';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import SchoolIcon from '@mui/icons-material/School';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import StarIcon from '@mui/icons-material/Star';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import InfoIcon from '@mui/icons-material/Info';
import NoteIcon from '@mui/icons-material/Note';
import ArticleIcon from '@mui/icons-material/Article';
import toast, { Toaster } from 'react-hot-toast';
import PrintCertificate from './PrintCertificate';

export const API_BASE = 'http://localhost:3000/api';
export const KRUTI_FONT = 'Kruti Dev 010';

const convertToKrutiDev = (text) => {
  if (!text) return "";
  const engToKruti = {
    'a':'ं','b':'इ','c':'ब','d':'क','e':'म','f':'ा','g':'ह','h':'ी','i':'प','j':'र','k':'ा','l':'स','m':'उ','n':'द','o':'व','p':'च','q':'ु','r':'त','s':'े','t':'ज','u':'न','v':'अ','w':'ा','x':'ग','y':'ल','z':'क्र',
    'A':'ा','B':'ब्','C':'च्','D':'क्','E':'म्','F':'ा','G':'ह','H':'ी','I':'प्','J':'र्','K':'ा','L':'स्','M':'श्','N':'न्','O':'व्','P':'च्','Q':'त्','R':'त्','T':'ज्','U':'न्','V':'अ','W':'ा','X':'ग्','Z':'क्र',
    '1':'१','2':'२','3':'३','4':'४','5':'५','6':'६','7':'७','8':'८','9':'९','0':'०'
  };
  let r = "";
  for (let i = 0; i < text.length; i++) r += engToKruti[text[i]] !== undefined ? engToKruti[text[i]] : text[i];
  return r;
};

const rawEnglishNames = ['swapnali', 'monika', 'harsh', 'yash', 'sushant', 'sachin', 'samiksha'];
const studentNamesList = rawEnglishNames.map(name => convertToKrutiDev(name));

const convertDateToKrutiWords = (dateString) => {
  if (!dateString) return "";
  const parts = dateString.split('-');
  if (parts.length !== 3) return "";
  const day = parseInt(parts[2], 10), month = parseInt(parts[1], 10), year = parseInt(parts[0], 10);
  const nums = {1:"एक",2:"दोन",3:"तीन",4:"चार",5:"पाच",6:"सहा",7:"सात",8:"आठ",9:"नऊ",10:"दहा",11:"अकरा",12:"बारा",13:"तेरा",14:"चौदा",15:"पंधरा",16:"सोळा",17:"सतरा",18:"अठरा",19:"एकोणीस",20:"वीस",21:"एकवीस",22:"बावीस",23:"तेवीस",24:"चोवीस",25:"पंचवीस",26:"सव्वीस",27:"सत्तावीस",28:"अठ्ठावीस",29:"एकोणतीस",30:"तीस",31:"एकतीस"};
  const months = {1:"जानेवारी",2:"फेब्रुवारी",3:"मार्च",4:"एप्रिल",5:"मे",6:"जून",7:"जुलै",8:"ऑगस्ट",9:"सप्टेंबर",10:"ऑक्टोबर",11:"नोव्हेंबर",12:"डिसेंबर"};
  const yr = year >= 2000 && year < 2100 ? "दोन हजार " + (year===2000?"":nums[year-2000]||year-2000) : year >= 1900 ? "एकोणीसशे "+(nums[year-1900]||year-1900) : year.toString();
  return convertToKrutiDev(`${nums[day]||day} ${months[month]||month} ${yr}`);
};

export const doPrint = () => {
  window.print();
};

const BLUE = 'rgb(3, 117, 138)';
const BLUE_DARK = '#037589ff';
const BLUE_BG = '#e8f0fb';

const theme = createTheme({
  palette: { mode: 'light', primary: { main: BLUE }, background: { default: '#eef2f7', paper: '#ffffff' } },
  typography: { fontFamily: ['Noto Sans Devanagari','Mangal','Arial','sans-serif'].join(',') },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        html, body { 
          background: #eef2f7 !important; 
          margin: 0; 
          padding: 0; 
          width: 100%; 
          min-height: 100vh;
          height: auto !important;
          overflow-x: hidden;
          overflow-y: auto !important;
        }
        #exact-certificate-print-view { display: none; }
        @media print {
          .no-print-zone { display: none !important; }
          #exact-certificate-print-view { display: block !important; border: none !important; padding: 0 !important; margin: 0 !important; background: #fff !important; color: #000 !important; width: 100% !important; }
          @page { size: A4 portrait; margin: 6mm 10mm 6mm 10mm; }
        }
      `,
    },
  },
});

const Field = ({ label, value, onChange, type = 'text', icon, kruti = false, children, onKeyDown, name }) => {
  const [focused, setFocused] = useState(false);
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      gap: '4px', 
      width: '100%', 
      maxWidth: '100%', 
      position: 'relative',
      boxSizing: 'border-box'
    }}>
      <Typography sx={{
        fontSize: { xs: '0.8rem', md: '0.88rem' },
        fontWeight: 700,
        color: '#334155',
        letterSpacing: '0.01em',
        lineHeight: 1.2,
        pl: '2px'
      }}>
        {label}
      </Typography>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        border: focused ? `2px solid ${BLUE}` : '1.5px solid #cbd5e1',
        borderRadius: '8px',
        background: '#fff',
        overflow: 'hidden',
        width: '100%', 
        boxSizing: 'border-box',
        boxShadow: focused ? `0 0 0 3px #dbeafe` : 'none',
        transition: 'border-color 0.15s, box-shadow 0.15s',
      }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: { xs: 40, md: 44 },
          minHeight: { xs: 44, md: 48 },
          background: BLUE_BG,
          borderRight: focused ? `2px solid ${BLUE}` : '1.5px solid #cbd5e1',
          flexShrink: 0,
          color: BLUE,
          '& svg': { fontSize: { xs: 18, md: 20 } },
        }}>
          {icon}
        </Box>
        <Box
          component="input"
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          onFocus={() => setFocused(true)}
          onBlur={() => setTimeout(() => setFocused(false), 250)}
          sx={{
            flex: 1,
            width: '100%', 
            minWidth: 0,   
            border: 'none',
            outline: 'none',
            padding: { xs: '10px 12px', md: '12px 14px' },
            fontSize: { xs: '0.95rem', md: '1rem' },
            fontWeight: 500,
            color: '#0f172a',
            background: 'transparent',
            fontFamily: kruti ? "'Kruti Dev 010', sans-serif" : 'inherit',
            boxSizing: 'border-box',
            '&[type=date]': { color: '#475569', height: '100%' },
          }}
        />
      </Box>
      {focused && children}
    </Box>
  );
};

const Row3 = ({ children }) => (
  <Box sx={{
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
    gap: { xs: 2, md: 2.5 },
    mb: { xs: 2, md: 2.5 },
    width: '100%',
    boxSizing: 'border-box'
  }}>
    {children}
  </Box>
);

const Row2_full = ({ children }) => (
  <Box sx={{
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: '2fr 1fr' },
    gap: { xs: 2, md: 2.5 },
    mb: { xs: 2, md: 2.5 },
    width: '100%',
    boxSizing: 'border-box'
  }}>
    {children}
  </Box>
);

const SectionHeading = ({ num, label }) => (
  <Box sx={{ display: 'flex', alignItems: 'stretch', width: '100%' }}>
    <Box sx={{
      background: BLUE_DARK,
      color: '#fff',
      px: { xs: 1.8, md: 2.5 },
      py: 1.2,
      fontSize: { xs: '0.85rem', md: '0.9rem' },
      fontWeight: 800,
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      flexShrink: 0,
      '&::after': {
        content: '""',
        position: 'absolute',
        right: -12,
        top: 0,
        borderTop: '22px solid transparent',
        borderBottom: '22px solid transparent',
        borderLeft: `12px solid ${BLUE_DARK}`,
        zIndex: 2,
      },
    }}>
      {num}
    </Box>
    <Box sx={{
      px: { xs: 2, md: 3.5 },
      display: 'flex',
      alignItems: 'center',
      fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem' },
      fontWeight: 700,
      color: BLUE_DARK,
      letterSpacing: '0.01em',
      lineHeight: 1.3
    }}>
      {label}
    </Box>
  </Box>
);

const Section = ({ children }) => (
  <Box sx={{ bgcolor: '#ffffff', borderRadius: { xs: '12px', md: '14px' }, border: '1.5px solid #d0daea', mb: { xs: 2.5, md: 3 }, overflow: 'hidden' }}>
    {children}
  </Box>
);

const SectionBody = ({ children }) => (
  <Box sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>{children}</Box>
);

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    studentId:'', uidNo:'', aadharCard:'',
    dakhalNo:'', anuKramank:'', registerNo:'',
    firstName:'', middleName:'', lastName:'', motherName:'',
    nationality:'', motherTongue:'', religion:'', caste:'', subCaste:'',
    birthPlace:'', taluka:'', district:'', dobDigit:'', dobWords:'',
    prevSchool:'', admissionDate:'', admissionClass:'', progress:'', conduct:'',
    currentClassDetails:'', leavingDate:'', leavingReason:'', remark:'',
    generalRegisterNo:'', dateDay:'', dateMonth:'', dateYear:''
  });

  const [filteredNames, setFilteredNames] = useState([]);
  // 🛠️ कीबोर्ड सिलेक्शन ट्रॅक करण्यासाठी नवीन स्टेट
  const [focusedIndex, setFocusedIndex] = useState(-1);

  const handleFormKeyDown = (e) => {
    // जर युझर पहिल्या नावाच्या फील्डवर असेल आणि ड्रॉपडाऊन ओपन असेल, तर जुना Enter रोखायचा
    if (e.key === 'Enter') {
      if (e.target.name === 'firstName' && filteredNames.length > 0) {
        return; 
      }
      e.preventDefault();
      const inputs = Array.from(e.currentTarget.querySelectorAll('input,textarea,select,button'));
      const next = inputs[inputs.indexOf(e.target) + 1];
      if (next) next.focus();
    }
  };

  // 🛠️ नेम इनपुट फील्डसाठी विशेष कीबोर्ड नेव्हिगेशन इव्हेंट
  const handleNameKeyDown = (e) => {
    if (filteredNames.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setFocusedIndex((prev) => (prev < filteredNames.length - 1 ? prev + 1 : 0));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setFocusedIndex((prev) => (prev > 0 ? prev - 1 : filteredNames.length - 1));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (focusedIndex >= 0 && focusedIndex < filteredNames.length) {
        handleSelectName(filteredNames[focusedIndex]);
      }
    } else if (e.key === 'Escape') {
      setFilteredNames([]);
      setFocusedIndex(-1);
    }
  };

  const handleChange = (field) => (e) => {
    let val = e.target.value;

    if (field === 'firstName') {
      const lastChar = val.slice(-1);
      const isEnglishInput = /[a-zA-Z0-9]/.test(lastChar);
      
      if (isEnglishInput) {
        val = convertToKrutiDev(val);
      }

      if (val.trim() !== '') {
        const matches = studentNamesList.filter(name => 
          name.toLowerCase().startsWith(val.toLowerCase())
        );
        setFilteredNames(matches);
        setFocusedIndex(0); // ड्रॉपडाऊन आल्यावर पहिल्या नावावर फोकस सेट करा
      } else {
        setFilteredNames([]);
        setFocusedIndex(-1);
      }
    } else {
      const nonKruti = ['studentId','uidNo','aadharCard','admissionDate','leavingDate','dateDay','dateMonth','dateYear','dobDigit','dakhalNo','anuKramank','registerNo','generalRegisterNo'];
      if (!nonKruti.includes(field)) val = convertToKrutiDev(val);
    }

    const updated = { ...formData, [field]: val };
    if (field === 'dobDigit') updated.dobWords = convertDateToKrutiWords(val);
    setFormData(updated);
  };

  const handleSelectName = (selectedName) => {
    setFormData({ ...formData, firstName: selectedName });
    setFilteredNames([]); 
    setFocusedIndex(-1);
  };

  const handleSaveAction = () => {
    toast((t) => (
      <Box sx={{ p: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 700, mb: 1.5, color: '#0f172a' }}>
          डेटा यशस्वीरित्या जतन केला! दाखला प्रिंट करायचा का?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button size="small" variant="outlined" color="error" onClick={() => toast.dismiss(t.id)}>नाही</Button>
          <Button size="small" variant="contained" onClick={() => { toast.dismiss(t.id); doPrint(); }}>होय (प्रिंट)</Button>
        </Box>
      </Box>
    ), { duration: 8000, position: 'top-center', style: { background:'#fff', boxShadow:'0 8px 32px rgba(0,0,0,0.12)', borderRadius:'12px', padding:'16px', minWidth:'290px', maxWidth: '95vw' } });
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Toaster />

      <Box sx={{ width: '100%', px: { xs: 1.1, sm: 2, md: 3 }, py: { xs: 4, md: 4 }, boxSizing: 'border-box' }} className="no-print-zone" onKeyDown={handleFormKeyDown}>

        {/* HEADER */}
        <Box sx={{ textAlign: 'center', mb: { xs: 3, md: 4 } }}>
          <Box 
            sx={{ 
              display: 'inline-block',
              background: `linear-gradient(135deg, ${BLUE} 0%, ${BLUE_DARK} 100%)`, 
              color: '#ffffff', 
              padding: { xs: '6px 24px', sm: '8px 34px', md: '10px 64px' }, 
              borderRadius: '6px',
              boxShadow: '0 8px 16px rgba(0,0,0,0.12)', 
              clipPath: 'polygon(4% 0%, 96% 0%, 100% 50%, 96% 100%, 4% 100%, 0% 50%)',
              position: 'relative'
            }}
          >
            <Typography 
              variant="h4" 
              sx={{
                fontWeight: 800,
                letterSpacing: '-0.2px', 
                fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' }, 
                fontFamily: "'Poppins', sans-serif",
                color: '#ffffff',
                lineHeight: 1.2, 
                textShadow: '0 1px 3px rgba(0,0,0,0.2)' 
              }}
            >
              विद्यार्थी नोंदणी अर्ज
            </Typography>
          </Box>
          <Box sx={{ mt: 1.5, height: '3px', background: BLUE, borderRadius: '2px', width: '100%' }} />
        </Box>

        {/* SECTION 1 */}
        <Section>
          <SectionHeading num="१" label=" नोंदणी क्रमांक" />
          <SectionBody>
            <Row3>
              <Field label="स्टूडंट आय.डी." value={formData.studentId} onChange={handleChange('studentId')} icon={<BadgeIcon />} />
              <Field label="यु.आय.डी. नं." value={formData.uidNo} onChange={handleChange('uidNo')} icon={<FingerprintIcon />} />
              <Field label="आधार कार्ड नंबर" value={formData.aadharCard} onChange={handleChange('aadharCard')} icon={<BadgeIcon />} />
            </Row3>
            <Row3>
              <Field label="दाखल नंबर" value={formData.dakhalNo} onChange={handleChange('dakhalNo')} icon={<AssignmentIcon />} />
              <Field label="अनुक्रमांक" value={formData.anuKramank} onChange={handleChange('anuKramank')} icon={<FormatListNumberedIcon />} />
              <Field label="रजिस्टर नंबर" value={formData.registerNo} onChange={handleChange('registerNo')} icon={<MenuBookIcon />} />
            </Row3>
          </SectionBody>
        </Section>

        {/* SECTION 2 */}
        <Section>
          <SectionHeading num="२" label="विद्यार्थ्याची वैयक्तिक माहिती" />
          <SectionBody>
            <Row3>
              <Field 
                name="firstName"
                label="विद्यार्थ्याचे नांव" 
                value={formData.firstName} 
                onChange={handleChange('firstName')} 
                onKeyDown={handleNameKeyDown} // 🛠️ कीबोर्ड इव्हेंट जोडला
                icon={<PersonIcon />}
                kruti={true}
              >
                {filteredNames.length > 0 && (
                  <Box sx={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    zIndex: 10,
                    background: '#ffffff',
                    border: '1.5px solid #cbd5e1',
                    borderRadius: '6px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    maxHeight: '160px',
                    overflowY: 'auto',
                    mt: '4px'
                  }}>
                    {filteredNames.map((name, idx) => (
                      <Box 
                        key={idx}
                        onClick={() => handleSelectName(name)}
                        sx={{
                          padding: '10px 14px',
                          cursor: 'pointer',
                          fontWeight: 500,
                          // 🛠️ कीबोर्ड हायलाईटसाठी कंडिशनल बॅकग्राउंड
                          background: idx === focusedIndex ? BLUE_BG : 'transparent',
                          color: idx === focusedIndex ? BLUE : '#0f172a',
                          fontSize: '1.1rem',
                          fontFamily: "'Kruti Dev 010', sans-serif",
                          borderBottom: idx !== filteredNames.length - 1 ? '1px solid #f1f5f9' : 'none',
                          '&:hover': { background: BLUE_BG, color: BLUE }
                        }}
                      >
                        {name}
                      </Box>
                    ))}
                  </Box>
                )}
              </Field>

              <Field label="वडिलांचे नांव" value={formData.middleName} onChange={handleChange('middleName')} icon={<PersonIcon />} kruti />
              <Field label="आडनांव" value={formData.lastName} onChange={handleChange('lastName')} icon={<PersonIcon />} kruti />
            </Row3>
            <Row3>
              <Field label="आईचे नांव" value={formData.motherName} onChange={handleChange('motherName')} icon={<FavoriteIcon />} kruti />
              <Field label="राष्ट्रीयत्व" value={formData.nationality} onChange={handleChange('nationality')} icon={<LanguageIcon />} kruti />
              <Field label="मातृभाषा" value={formData.motherTongue} onChange={handleChange('motherTongue')} icon={<ChatBubbleIcon />} kruti />
            </Row3>
            <Row3>
              <Field label="धर्म" value={formData.religion} onChange={handleChange('religion')} icon={<SelfImprovementIcon />} kruti />
              <Field label="जात" value={formData.caste} onChange={handleChange('caste')} icon={<GroupsIcon />} kruti />
              <Field label="पोटजात" value={formData.subCaste} onChange={handleChange('subCaste')} icon={<PeopleIcon />} kruti />
            </Row3>
            <Row3>
              <Field label="जन्म गांव / शहर" value={formData.birthPlace} onChange={handleChange('birthPlace')} icon={<LocationOnIcon />} kruti />
              <Field label="तालुका" value={formData.taluka} onChange={handleChange('taluka')} icon={<MapIcon />} kruti />
              <Field label="जिल्हा" value={formData.district} onChange={handleChange('district')} icon={<MapIcon />} kruti />
            </Row3>
            <Box sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 2fr' },
              gap: { xs: 2, md: 2.5 },
            }}>
              <Field label="जन्म दिनांक (अंकी)" value={formData.dobDigit} onChange={handleChange('dobDigit')} type="date" icon={<CalendarMonthIcon />} />
              <Field label="जन्म दिनांक (अक्षरी — ऑटो)" value={formData.dobWords} onChange={handleChange('dobWords')} icon={<TextFieldsIcon />} kruti />
            </Box>
          </SectionBody>
        </Section>

        {/* SECTION 3 */}
        <Section>
          <SectionHeading num="३" label="शैक्षणिक रेकॉर्ड व शाळा सोडल्याचा तपशील" />
          <SectionBody>
            <Row2_full>
              <Field label="यापूर्वीची शाळा व इयत्ता" value={formData.prevSchool} onChange={handleChange('prevSchool')} icon={<SchoolIcon />} kruti />
              <Field label="प्रवेश इयत्ता" value={formData.admissionClass} onChange={handleChange('admissionClass')} icon={<MenuBookIcon />} kruti />
            </Row2_full>
            <Row3>
              <Field label="या शाळेत प्रवेश दिनांक" value={formData.admissionDate} onChange={handleChange('admissionDate')} type="date" icon={<CalendarMonthIcon />} />
              <Field label="अभ्यासातील प्रगती" value={formData.progress} onChange={handleChange('progress')} icon={<AutoGraphIcon />} kruti />
              <Field label="वर्तणूक" value={formData.conduct} onChange={handleChange('conduct')} icon={<StarIcon />} kruti />
            </Row3>
            <Row3>
              <Field label="कोणत्या इयत्तेत शिकत होता" value={formData.currentClassDetails} onChange={handleChange('currentClassDetails')} icon={<LibraryBooksIcon />} kruti />
              <Field label="शाळा सोडल्याचा दिनांक" value={formData.leavingDate} onChange={handleChange('leavingDate')} type="date" icon={<EventBusyIcon />} />
              <Field label="शाळा सोडल्याचे कारण" value={formData.leavingReason} onChange={handleChange('leavingReason')} icon={<InfoIcon />} kruti />
            </Row3>
            <Field label="शेरा (Remarks)" value={formData.remark} onChange={handleChange('remark')} icon={<NoteIcon />} kruti />
          </SectionBody>
        </Section>

        {/* SECTION 4 */}
        <Section>
          <SectionHeading num="४" label="जनरल रजिस्टर प्रमाणीकरण आणि दिनांक" />
          <SectionBody>
            <Box sx={{
              display: 'grid',
              gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(2, 1fr)', md: '3fr 1fr 1fr 1fr' },
              gap: { xs: 2, md: 2.5 },
            }}>
              <Box sx={{ gridColumn: { xs: 'span 2', md: 'span 1' } }}>
                <Field label="शाळेतील जनरल रजिस्टर नं." value={formData.generalRegisterNo} onChange={handleChange('generalRegisterNo')} icon={<ArticleIcon />} />
              </Box>
              <Field label="तारीख (Day)" value={formData.dateDay} onChange={handleChange('dateDay')} icon={<CalendarMonthIcon />} />
              <Field label="माहे (Month)" value={formData.dateMonth} onChange={handleChange('dateMonth')} icon={<CalendarMonthIcon />} />
              <Field label="सन (Year)" value={formData.dateYear} onChange={handleChange('dateYear')} icon={<CalendarMonthIcon />} />
            </Box>
          </SectionBody>
        </Section>

        {/* BUTTONS */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: { xs: 'stretch', sm: 'flex-end' }, 
          pt: 1,
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <Button 
            variant="contained" 
            disableElevation 
            startIcon={<SaveIcon />} 
            onClick={handleSaveAction}
            sx={{
              bgcolor: '#037589ff',
              '&:hover': { bgcolor: 'rgb(9, 100, 116)' },
              borderRadius: '8px',
              px: { xs: 2, sm: 4 },   
              py: 1.5,
              fontWeight: 700,
              textTransform: 'none',
              width: { xs: '100%', sm: 'auto' },  
              minWidth: 0,   
            }}
          >
            डेटा जतन करा
          </Button>
        </Box>

      </Box>

      <PrintCertificate formData={formData} />
    </ThemeProvider>
  );
};

export default RegistrationForm;